module.exports = __webpack_public_path__ + "img/detective-working.gif";